import './Dashboard.scss';

import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router';

import { useGetLookerReports } from '@/src/components/project/Settings/components/Account/Dashboard/hooks/useGetLookerReports';

import Conversations from './components/Conversations/Conversations';
import Counters from './components/Counters/Counters';
import SubtaskReports from './components/SubtaskReports/SubtaskReports';
import Workspace from '../../workspace';

// Extend Window interface to include mainApp
declare global {
  interface Window {
    mainApp?: {
      moveLookerIframeToAnchor?: () => void;
    };
  }
}

interface ProjectDashboardParams {
  projectId: string;
}

interface ProjectDashboardProps {
  iframeCache: any;
  setIframeCache: (cb: any) => void;
}

const ProjectDashboard: React.FC<ProjectDashboardProps> = () => {
  const { projectId } = useParams<ProjectDashboardParams>();
  const location = useLocation();
  const dispatch = useDispatch();

  const { lookerReports } = useGetLookerReports(String(projectId), {
    config: { enabled: !!projectId },
  });

  useEffect(() => {
    if (lookerReports) {
      dispatch({
        type: 'SET_PROJECT_SELECTED',
        Selected: {
          lookerReportsUrls: lookerReports,
        },
      });
    }
  }, [dispatch, lookerReports]);

  const displayLookerReport = false;

  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    if (qs && qs.get('new') == '1') {
      // @ts-ignore
      $('#proceedToDetailsModal').modal('show');
    }
  }, [location.search]);

  return (
    <div
      className={clsx(
        'row content-row',
        '!tw-m-0 tw-py-[20px]',
        'tw-h-[calc(100vh-107px)]',
        'tw-overflow-y-auto tw-scroll-styles'
      )}
    >
      {/** Full width default standard dashboard */}
      <>
        <div className="tw-w-full tw-flex tw-flex-container tw-px-[15px] tw-mb-[20px]">
          <SubtaskReports projectId={projectId} key={`str_${projectId}`} isReportsEnabled={false} />
        </div>
        <div className="tw-w-full tw-flex tw-flex-container tw-px-[15px] tw-mb-[20px]">
          <Counters projectId={projectId} />
          <Conversations projectId={projectId} />
        </div>
        <div style={{ marginTop: 16 }}>
          <Workspace isReportsEnabled={displayLookerReport} />
        </div>
      </>
    </div>
  );
};

export default ProjectDashboard;
